import { StoreConfigurationNotFoundError } from '@ordering/Error/StoreConfigurationNotFoundError';

import getClient from '@ordering/urql/getClient';
import { getMerchantBySlugQuery } from '@ordering/queries/getMerchantbySlug';

export const getMerchantBySlug = async (merchantSlug: string, storefrontSlug: string) => {
  if (!merchantSlug || !storefrontSlug) {
    console.error('getStorefront can only be used when a page has both the merchantCode and locationCode');
  }

  const start = Date.now();
  const config = await getClient().query(
    getMerchantBySlugQuery,
    {
      storefrontSlugs: {
        merchantSlug,
        storefrontSlug,
      },
    },
    {
      requestPolicy: 'cache-and-network',
    }
  );
  const end = Date.now();
  if (config.error) console.log(JSON.stringify(config.error));
  console.log(`getStorefront took ${end - start}ms`);

  if (config.error || !config.data || !config.data.getStorefrontBySlug) {
    console.error('Error fetching merchant by slug', JSON.stringify(config.error));
    throw new StoreConfigurationNotFoundError(merchantSlug, storefrontSlug);
  }

  return config.data.getStorefrontBySlug.details;
};
